module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/centrum-9bb26326a8cc1c079cfc7cb08f31f065.png";